import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';

@Component({
    selector: 'ew-delete-provider',
    templateUrl: './delete-provider.component.html',
    styleUrls: ['./delete-provider.component.scss'],
})
export class DeleteProviderComponent {
    success: boolean = false;
    loading: boolean = true;

    constructor(
        private API: ApiService,
        private MD: MatDialogRef<DeleteProviderComponent>,
        @Inject(MAT_DIALOG_DATA)
        public dialogData: { bankAccountId: string, alias: string },
    ) { }

    deleteProvider(): void {
        const { bankAccountId } = this.dialogData;
        this.API.delete(`v1/bank-accounts/beneficiary/${bankAccountId}`).subscribe(
            () => {
                this.loading = false;
                this.success = true;
                this.MD.close(true);
                this.API.alertService
                    .success('deleteProvider:success')
                    .on('beforeHide', () => {
                        window.location.reload();
                    });
            },
            () => {
                this.loading = false;
                this.success = false;
            },
        );
    }
} 